import {Component, ElementRef, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Utils} from '../../utils/utils';
import {ImageModalComponent} from '../image-modal/image-modal.component';
import {Dialog} from "@angular/cdk/dialog";

@Component({
  selector: 'app-input-image-upload',
  templateUrl: './input-image-upload.component.html',
  styleUrls: ['./input-image-upload.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => InputImageUploadComponent),
    multi: true
  }]
})
export class InputImageUploadComponent implements ControlValueAccessor {

  photo: string;
  @Input() resizeTo = 720;
  @Input() imageQuality = 90;
  @Input() name: string;
  @Input() label: string;

  public onChangeCallback: (_: any) => void = () => {
  };
  public onTouchedCallback: () => void = () => {
  };


  constructor(
    private el: ElementRef,
    private dialog: Dialog,
  ) {
  }

  writeValue(photo: string): void {
    this.photo = photo;
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }


  clickImage() {
    if (this.photo) {
      // show modal
      console.log('show modal');
      let model = {photo: this.photo, label: 'modal_' + this.label, resizeTo: this.resizeTo};
      let modalSub = this.dialog.open(ImageModalComponent, {data: model}).closed.subscribe((photo: string | null | undefined) => {

        modalSub.unsubscribe();
        if (photo === undefined) {  // undefined value is used to indicate that the modal was closed via top right X button
          return;
        }
        this.photo = photo;
        this.onChangeCallback(this.photo);

      });

    } else {
      this.selectFile();
    }
  }


  selectFile() {
    document.getElementById('input_' + this.name).click();
  }

  isInvalid(): boolean {
    const classList = Array.from(this.el.nativeElement.classList);
    const touched = classList.includes('ng-touched');
    const invalid = classList.includes('ng-invalid');
    return touched && invalid;
  }

  public async processFile(e: Event) {
    const file = (e.target as HTMLInputElement)?.files[0];
    const dataUrl = await Utils.resizeImage(file, this.resizeTo, true, this.imageQuality);

    const htmlImageElement = document.getElementById('image_' + this.name) as HTMLImageElement;
    htmlImageElement.src = dataUrl.toString();

    this.photo = typeof dataUrl === 'string' ? dataUrl.split(';base64,')[1] : '';
    this.onChangeCallback(this.photo);
  }

}
